import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const  resource_new = "/customer";
export default {
  getProjectBriefs(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/project_briefs?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getSingleProjectBrief(id) {
    return Repository.get(`${resource_new}/project_briefs/${id}`)
  },
  createCustomerProjectBrief(payload) {
    return Repository.post(`${resource_new}/project_briefs`, payload)
  },
  updateCustomerProjectBrief(id, payload) {
    return Repository.put(`${resource_new}/project_briefs/${id}`, payload)
  },
  submitCustomer() {
    return Repository.put(`${resource_new}/submission`)
  },
  getCustomerRoles() {
    return Repository.get(`${resource_new}/roles`)
  },


  getCustomerAccountCredit(){
    return Repository.get(`${resource_new}/account_credits`)
  },

  getAccountLimitRequestList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/credit_requests?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getAccountLimitRequest(id){
    return Repository.get(`${resource_new}/credit_requests/${id}`)
  },
  createAccountLimitRequest(payload){
    return Repository.post(`${resource_new}/credit_requests`, payload)
  },


  //orders sample
  getListOfSamples(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/sample_orders?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerSampleOrder(id) {
    return Repository.get(`${resource_new}/sample_orders/${id}`)
  },
  createCustomerSampleOrder(payload) {
    return Repository.post(`${resource_new}/sample_orders`, payload)
  },
  updateCustomerSampleOrder(id, payload) {
    return Repository.put(`${resource_new}/sample_orders/${id}`, payload)
  },
  statusChangeCustomerSampleOrders(id, status){
    return Repository.put(`${resource_new}/sample_order/${status}/${id}`)
  },
  getSampleDeliveryAddresses() {
    return Repository.get(`${resource_new}/sample_delivery_addresses`)
  },

  getSampleList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/sample_list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },

  getItemsInItemsCart() {
    return Repository.get(`${resource_new}/sample_carts`)
  },
  addFormulationsToCart(payload) {
    return Repository.post(`${resource_new}/sample_carts`, payload)
  },
  removeFormulationsFromCart(id) {
    return Repository.delete(`${resource_new}/sample_carts/${id}`)
  },
  updateFormulationSampleCart(id, payload) {
    return Repository.put(`${resource_new}/sample_carts/${id}`, payload)
  },


  // PRODUCT CONTRACTS
  getListOfProductContracts(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/product_contracts?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },

  //Product orders

  getListOfProductOrders(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/product_orders?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerProductOrder(id) {
    return Repository.get(`${resource_new}/product_orders/${id}`)
  },
  createCustomerProductOrder(payload) {
    return Repository.post(`${resource_new}/product_orders`, payload)
  },
  updateCustomerProductOrder(id, payload) {
    return Repository.put(`${resource_new}/product_orders/${id}`, payload)
  },
  updateProductOrderContent(id, payload) {
    return Repository.put(`${resource_new}/product_order_content/${id}`, payload)
  },
  changeRmOrderHandleType(id) {
    return Repository.put(`${resource_new}/product_order/${id}/item_status_handle`)
  },

  getListOfProductCatalogue(filterQuery) {
    return Repository.get(`${resource_new}/product_catalogue?${filterQuery}`)
  },
  getCustomerProductDeliveryAddresses() {
    return Repository.get(`${resource_new}/product_delivery_addresses`)
  },
  getShipmentPdfData(id) {
    return Repository.get(`${resource_new}/shipment/${id}/delivery-note-pdf-data`)
  },

  getItemsInProductCart() {
    return Repository.get(`${resource_new}/product_carts`)
  },
  addFormulationsToProductCart(payload) {
    return Repository.post(`${resource_new}/product_carts`, payload)
  },
  removeFormulationsFromProductCart(id) {
    return Repository.delete(`${resource_new}/product_carts/${id}`)
  },
  updateFormulationsQuantityInProductCart(id, payload) {
    return Repository.put(`${resource_new}/product_carts/${id}`, payload)
  },

  statusChangeCustomerProductOrders(id, status){
    return Repository.put(`${resource_new}/product_order/${status}/${id}`)
  },
  productOrdersItemStatusChange(id, payload) {
    return Repository.put(`${resource_new}/product_order_item/${id}/status`, payload)
  },

  getProductCatalogueList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/product_catalogue?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },

  //2FA
  get2FAImageQR(customer_user_id) {
    return Repository.get(`${resource_new}/2fa/${customer_user_id}/show-2fa-code`)
  },
  enable2FA(customer_user_id, payload) {
    return Repository.put(`${resource_new}/2fa/${customer_user_id}/enable-2fa`, payload)
  },

  //sales quote
  getSalesQuotationList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/customer/sale-quotes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSalesQuoteData(secret) {
    return Repository.get(`/customer/sale-quote/${secret}/data`)
  },

  getCreditNoteList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/customer/credit-notes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getCreditNoteData(secret) {
    return Repository.get(`/customer/credit-note/${secret}/pdf-data`)
  },
  getListOfChangeReques(id) {
    return Repository.get(`/customer/product-order-items/${id}/change-requests`)
  },
  submitOrderItemChangeRequest(id, payload) {
    return Repository.post(`/customer/product-order-items/${id}/change-requests`, payload)
  }

};
